const columns = () => ([
  {
    title: 'Order ID',
    dataIndex: 'order_id',
    key: 'order_id',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Is PM user',
    dataIndex: 'is_pm_user',
    key: 'is_pm_user',
    customRender: ({ text }) => (text ? 'Yes' : 'No'),
  },
]);

export default columns;
